import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableDelinqunecy from "./components/TableDelinqunecy";

export function DelinquencyRegisterPage() {

  return (
    <ToastProvider>
      <Dashboard>
        <TableDelinqunecy />
        <Toast />
      </Dashboard>
    </ToastProvider>
  )
}